import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaTrashAlt, FaEdit, FaToggleOn, FaToggleOff } from "react-icons/fa";
import AOS from "aos";

const initialData = [
  { name: "Jai Hind Inter College", owner: "Admin User", lastModified: "30 Aug 7:30 PM", modifiedBy: "Admin User", status: "Active" },
  { name: "Kids Heaven School", owner: "Admin User", lastModified: "29 Aug 6:00 PM", modifiedBy: "Admin User", status: "Inactive" },
  { name: "Gandhi Inter College", owner: "Admin User", lastModified: "28 Aug 5:00 PM", modifiedBy: "Admin User", status: "Active" },
];

const PartnerTable = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


    useEffect(() => {
      AOS.init({
        startEvent: "DOMContentLoaded",
        disable: function () {
          var maxWidth = 996;
          return window.innerWidth < maxWidth;
        },
        throttleDelay: 10,
        once: true,
        duration: 700,
        offset: 10,
      });
    });
   

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.owner.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.modifiedBy.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const handleDelete = (index) => {
    const newData = data.filter((_, i) => i !== index);
    setData(newData);
    alert(`Entry ${index + 1} deleted successfully.`);
  };

  const handleToggleStatus = (index) => {
    const newData = [...data];
    newData[index].status = newData[index].status === "Active" ? "Inactive" : "Active";
    setData(newData);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
 
              <h3>Partner</h3>
              <div className="d-flex align-items-center">
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button variant="light" className="me-2">
                  <FaRedo />
                </Button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
              </div>
            </Card.Header>
            <Card.Body>
              <div
                className="table-responsive border border-secondary rounded"
                style={{ padding: "1rem" }}
              >
                <Table hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("name")}>
                        Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("owner")}>
                        Owner <FaSort />
                      </th>
                      <th onClick={() => handleSort("lastModified")}>
                        Last Modified <FaSort />
                      </th>
                      <th onClick={() => handleSort("modifiedBy")}>
                        Modified By <FaSort />
                      </th>
                      <th onClick={() => handleSort("status")}>
                        Status <FaSort />
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, index) => (
                      <tr key={index}>
                        <td className="d-flex align-items-center">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              backgroundColor: "#007bff",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginRight: "10px",
                            }}
                          >
                            {item.name[0]}
                          </div>
                          {item.name}
                        </td>
                        <td>{item.owner}</td>
                        <td>{item.lastModified}</td>
                        <td>{item.modifiedBy}</td>
                        <td>
                          <span
                            className={`badge ${
                              item.status === "Active"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              size="sm"
                              className="border-0"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => handleToggleStatus(index)}>
                                {item.status === "Active" ? (
                                  <FaToggleOff className="me-2 text-warning" />
                                ) : (
                                  <FaToggleOn className="me-2 text-success" />
                                )}
                                Toggle Status
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => alert(`Edit entry ${index + 1}`)}>
                                <FaEdit className="me-2 text-info" /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => handleDelete(index)}>
                                <FaTrashAlt className="me-2 text-danger" /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {!filteredData.length && (
                  <p className="text-center">No results found.</p>
                )}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {startIndex + 1} to{" "}
                    {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
                    {filteredData.length} entries
                  </div>
                  <div>
                    {[...Array(pageCount).keys()].map((page) => (
                      <Button
                        key={page}
                        variant="light"
                        className={`me-1 ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page + 1)}
                      >
                        {page + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PartnerTable;
